export const MAX_DEPENDENCIES_AMOUNT = 3;